import { lazy } from '@loadable/component';
import { cn } from '@simplywallst/ui-core/next';
import { Suspense } from 'react';

// Split content into a lazy component to avoid loading SVG content unless needed.
export const EasterPromoLoginSplashContent = lazy(() =>
  import('./EasterPromoLoginSplashContent').then((c) => ({
    default: c.EasterPromoLoginSplashContent,
  }))
);

export const EasterPromoLoginSplash = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            'relative h-[304px] overflow-hidden bg-[#F4F2EC] lg:h-full lg:min-h-[542px]',
            className
          )}
        />
      }
    >
      <EasterPromoLoginSplashContent className={className} />
    </Suspense>
  );
};
